export const InstanceTitle = 'TX Control'
export const SystemDashboardName = 'TX Control service'
export const ReservedVariableNames = ['networkAvailability']

export const AllNetworksSelection = {
    id: 'all',
    name: 'All networks',
}
